import { PropType, computed, defineComponent } from 'vue'
import { Store } from 'pinia'
import { MapViewMode, Point } from '../../../contract/map'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import WishIconRender from './wishIconRender'

/**
 * 心愿站大ICON渲染功能模块
 */
export type WishIconRenderProps = {
  onClickedVglMarker: (customMarkerData: Point | null) => void
}
export default defineComponent({
  name: 'wish-icon-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props, { expose }) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const componentStore = computed(() => props.componentStore)

    return () => (
      <>
        {componentStore.value.viewMode === MapViewMode.WishPower && (
          <>
            <WishIconRender
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              componentStore={componentStore.value}
            ></WishIconRender>
          </>
        )}
      </>
    )
  },
})
